import BigDataList from './big-data-list'
export default BigDataList
